import { defineStore } from 'pinia'
import axios from '@/utils/axios'
import { getBranches } from '@/utils/branch'

const CACHE_TIME = 10 * 60 * 1000 // 10 min

export const useLeadMetaStore = defineStore('leadMeta', {
  state: () => ({
    stages: [],
    sources: [],
    users: [],
    branches: [],
    lastFetch: 0
  }),

  persist: true,

  actions: {
    async loadAll(force = false) {
      const now = Date.now()
      const isFresh = this.lastFetch && (now - this.lastFetch) < CACHE_TIME
      const hasData = this.stages.length && this.sources.length && this.users.length && this.branches.length

      // Sab data hai + fresh hai -> API skip
      if (!force && isFresh && hasData) return

      // allSettled: ek call fail ho to baaki na ruke
      const results = await Promise.allSettled([
        axios.get('/lead-stages'),
        axios.get('/lead-sources'),
        axios.get('/users/all-users'),
        getBranches()
      ])

      const [stagesRes, sourcesRes, usersRes, branchesRes] = results

      if (stagesRes.status === 'fulfilled')   this.stages   = stagesRes.value.data.data
      if (sourcesRes.status === 'fulfilled')  this.sources  = sourcesRes.value.data.data
      if (usersRes.status === 'fulfilled')    this.users    = usersRes.value.data.data
      if (branchesRes.status === 'fulfilled') this.branches = branchesRes.value

      this.lastFetch = now
    },

    refresh() {
      return this.loadAll(true)
    },
    clearCache() {
    this.stages   = []
    this.sources  = []
    this.users    = []
    this.branches = []
    this.lastFetch = 0
    }
  }
})